import React from 'react';
import { useMediaQuery } from 'react-responsive';
import WebBuilderContent from './WebBuilderContent';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  return isDesktop ? children : null;
};

const DesktopResponsive = ({ history }) => (
  <Desktop>
    <WebBuilderContent history={history} />
  </Desktop>
);

export default DesktopResponsive;
